// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* All Open Orders */
.openorders-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.openorders-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.openorders-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.openorders-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.openorders-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.openorders-section__stats {
  display: flex;
  gap: 1.25rem;
}

.openorders-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.openorders-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.openorders-section__stats--actions {
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.openorders-export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.openorders-export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.openorders-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.openorders-refresh-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.openorders-refresh-btn:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
}

.openorders-refresh-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.openorders-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  flex: 0 1 120px;
}

.openorders-page-limit__select {
  max-width: none;
  margin: 0;
  min-width: 100px;
}

.openorders-toast {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 9999;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.openorders-toast--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.openorders-toast--error {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.openorders-search-wrap {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.openorders-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.openorders-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.openorders-search-input::placeholder {
  color: var(--text-muted);
}

.openorders-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.openorders-table-wrap {
  overflow-x: auto;
}

.openorders-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.openorders-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.openorders-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.openorders-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.openorders-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.openorders-table tbody tr:hover {
  background: #f0fdfa !important;
}

.openorders-table tbody tr:last-child td {
  border-bottom: none;
}

.openorders-order-id {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.openorders-side {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.openorders-side--buy,
.openorders-side--long {
  background: #dcfce7;
  color: #166534;
}

.openorders-side--sell,
.openorders-side--short {
  background: #fef2f2;
  color: #b91c1c;
}

.openorders-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

.openorders-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
}

.openorders-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.openorders-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.openorders-pagination__btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.openorders-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.openorders-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.openorders-cancel-btn {
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.35rem 0.7rem;
  border: none;
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  cursor: pointer;
  white-space: nowrap;
}

.openorders-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.openorders-cancel-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.openorders-cancel-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 460px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.35);
}

.openorders-cancel-modal__head {
  padding: 1.25rem 1.35rem 1rem;
  background: linear-gradient(125deg, #9a3412 0%, #c2410c 55%, #7c2d12 100%);
  color: #fff;
}

.openorders-cancel-modal__head h2 {
  margin: 0 0 0.35rem;
  font-size: 1.15rem;
  font-weight: 800;
  color: #fff;
}

.openorders-cancel-modal__head p {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.88);
}

.openorders-cancel-modal__body {
  padding: 1.15rem 1.35rem;
}

.openorders-cancel-modal__summary {
  margin: 0 0 1rem;
  padding: 0.75rem 0.9rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #334155;
}

.openorders-cancel-modal__summary strong {
  color: #0f172a;
}

.openorders-cancel-modal__warn {
  margin: 0;
  font-size: 0.82rem;
  color: #b45309;
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  line-height: 1.45;
}

.openorders-cancel-modal__error {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  color: #b91c1c;
}

.openorders-cancel-modal__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0 1.35rem 1.25rem;
}

.openorders-cancel-modal__keep,
.openorders-cancel-modal__confirm {
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.5rem 0.85rem;
}

.openorders-cancel-modal__keep {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
}

.openorders-cancel-modal__confirm {
  border: none;
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  color: #fff;
}

.openorders-cancel-modal__keep:disabled,
.openorders-cancel-modal__confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.text-green { color: #16a34a; font-weight: 500; }
.text-red { color: #dc2626; font-weight: 500; }
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/AllOpenOrdersPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc,cAAc,EAAE,gBAAgB,EAAE;AAChD,YAAY,cAAc,EAAE,gBAAgB,EAAE","sourcesContent":["/* All Open Orders */\n.openorders-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.openorders-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.openorders-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.openorders-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.openorders-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.openorders-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.openorders-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.openorders-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.openorders-section__stats--actions {\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.openorders-export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.openorders-export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.openorders-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.openorders-refresh-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.openorders-refresh-btn:hover:not(:disabled) {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.openorders-refresh-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.openorders-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex: 0 1 120px;\n}\n\n.openorders-page-limit__select {\n  max-width: none;\n  margin: 0;\n  min-width: 100px;\n}\n\n.openorders-toast {\n  position: fixed;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 9999;\n  padding: 0.75rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.openorders-toast--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.openorders-toast--error {\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.openorders-search-wrap {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.openorders-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.openorders-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.openorders-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.openorders-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.openorders-table-wrap {\n  overflow-x: auto;\n}\n\n.openorders-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.openorders-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.openorders-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.openorders-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.openorders-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.openorders-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.openorders-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.openorders-order-id {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.openorders-side {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.openorders-side--buy,\n.openorders-side--long {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.openorders-side--sell,\n.openorders-side--short {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.openorders-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.openorders-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n}\n\n.openorders-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.openorders-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.openorders-pagination__btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.openorders-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0f766e;\n}\n\n.openorders-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.openorders-cancel-btn {\n  font-family: inherit;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.35rem 0.7rem;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.openorders-cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.openorders-cancel-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.openorders-cancel-modal {\n  background: #fff;\n  border-radius: 16px;\n  max-width: 460px;\n  width: 100%;\n  overflow: hidden;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.35);\n}\n\n.openorders-cancel-modal__head {\n  padding: 1.25rem 1.35rem 1rem;\n  background: linear-gradient(125deg, #9a3412 0%, #c2410c 55%, #7c2d12 100%);\n  color: #fff;\n}\n\n.openorders-cancel-modal__head h2 {\n  margin: 0 0 0.35rem;\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n.openorders-cancel-modal__head p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.openorders-cancel-modal__body {\n  padding: 1.15rem 1.35rem;\n}\n\n.openorders-cancel-modal__summary {\n  margin: 0 0 1rem;\n  padding: 0.75rem 0.9rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  line-height: 1.55;\n  color: #334155;\n}\n\n.openorders-cancel-modal__summary strong {\n  color: #0f172a;\n}\n\n.openorders-cancel-modal__warn {\n  margin: 0;\n  font-size: 0.82rem;\n  color: #b45309;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  line-height: 1.45;\n}\n\n.openorders-cancel-modal__error {\n  margin: 0 0 0.75rem;\n  font-size: 0.85rem;\n  color: #b91c1c;\n}\n\n.openorders-cancel-modal__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0 1.35rem 1.25rem;\n}\n\n.openorders-cancel-modal__keep,\n.openorders-cancel-modal__confirm {\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.5rem 0.85rem;\n}\n\n.openorders-cancel-modal__keep {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n}\n\n.openorders-cancel-modal__confirm {\n  border: none;\n  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);\n  color: #fff;\n}\n\n.openorders-cancel-modal__keep:disabled,\n.openorders-cancel-modal__confirm:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.text-green { color: #16a34a; font-weight: 500; }\n.text-red { color: #dc2626; font-weight: 500; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
